import { z } from 'zod'

export const templateFieldSchema = z.object({
  key: z.string(),
  label: z.string(),
  type: z.enum(['text', 'textarea', 'checkbox', 'radio', 'image']),
  required: z.boolean(),
  maxLength: z.number().optional(),
  minLength: z.number().optional(),
  options: z.array(z.string()).optional(),
  placeholder: z.string().optional(),
})

export const templateFiledValueSchema = z.union([
  z.string(),
  z.array(z.string()),
])

export const templateFieldValuesSchema = z.record(templateFiledValueSchema)

export type TemplateFieldValues = z.infer<typeof templateFieldValuesSchema>

export const templateConfigSchema = z.array(templateFieldSchema)

export type TemplateConfig = z.infer<typeof templateConfigSchema>

export const templateMetadataSchema = z.object({
  specialScenario: z.enum(['chatLog']),
})

export type TemplateMetadata = z.infer<typeof templateMetadataSchema>
